export const config = {
  production: {
    REACT_APP_API_HOST: "https://api.datafiniti.co/v4",
    REACT_APP_STRIPE_SERVER: "https://portal.datafiniti.co/editBilling",
    REACT_APP_RECAPTCHA_SERVER: "https://portal.datafiniti.co/recaptcha",
    REACT_APP_TOKEN_SERVER: "https://portal.datafiniti.co/newToken",
    REACT_APP_SUBSCRIPTION_RENEW_SERVER: "https://portal.datafiniti.co/subscription-renew-date",
    REACT_APP_LOGIN_EVENT_SERVER: "https://portal.datafiniti.co/login-event",
  },
  qa: {
    REACT_APP_API_HOST: "http://api.qa.datafiniti.co",
    REACT_APP_STRIPE_SERVER: "http://qa.portal.datafiniti.co/editBilling",
    REACT_APP_RECAPTCHA_SERVER: "http://qa.portal.datafiniti.co/recaptcha",
    REACT_APP_TOKEN_SERVER: "http://qa.portal.datafiniti.co/newToken",
    REACT_APP_SUBSCRIPTION_RENEW_SERVER: "http://qa.portal.datafiniti.co/subscription-renew-date",
    REACT_APP_LOGIN_EVENT_SERVER: "http://qa.portal.datafiniti.co/login-event",
  },
  local: {
    REACT_APP_API_HOST: "http://localhost:9000",
    REACT_APP_STRIPE_SERVER: "http://localhost:9000/editBilling",
    REACT_APP_RECAPTCHA_SERVER: "http://localhost:9000/recaptcha",
    REACT_APP_TOKEN_SERVER: "http://localhost:9000/newToken",
    REACT_APP_SUBSCRIPTION_RENEW_SERVER: "http://localhost:9000/subscription-renew-date",
    REACT_APP_LOGIN_EVENT_SERVER: "http://localhost:9000/login-event",
  },
};
